import type { LogoColor, LogoState } from './logo.types';

export const LOGO_DEFAULT_ALT = 'Harbor Lab logo';

/** Decorative alt when the logo sits inside a named link (e.g. admin navbar brand). */
export const LOGO_DECORATIVE_ALT = '';

export const LOGO_ADMINISTRATOR_TAG_LABEL = 'ADMINISTRATOR';

export const LOGO_BASE_PATH = '/img/logo/';

export const LOGO_SRC_BY_VARIANT: Record<
  LogoColor,
  Record<LogoState, string>
> = {
  dark: {
    regular: `${LOGO_BASE_PATH}logo_dark_regular.svg`,
    minimized: `${LOGO_BASE_PATH}logo_dark_minimized.svg`,
    vertical: `${LOGO_BASE_PATH}logo_dark_vertical.svg`
  },
  light: {
    regular: `${LOGO_BASE_PATH}logo_light_regular.svg`,
    minimized: `${LOGO_BASE_PATH}logo_light_minimized.svg`,
    vertical: `${LOGO_BASE_PATH}logo_light_vertical.svg`
  }
};
